export default __webpack_public_path__ + "static/media/404_page.49211e2b.png";